import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-cautelare-view',
  templateUrl: './form-cautelare-view.component.html',
  styleUrls: ['./form-cautelare-view.component.css']
})
export class FormCautelareViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
